// This file is now a re-export of the refactored Users component
// The component has been split into multiple files for better maintainability
import Users from './Users/index';

export default Users;

// Original implementation has been moved to:
// - ./Users/Users.js (main component)
// - ./Users/components/UserTable.js (table component)
// - ./Users/components/UserDialog.js (dialog component)
// - ./Users/components/UserInfoTab.js (info tab)
// - ./Users/components/UserPTOTab.js (PTO tab)
// - ./Users/components/UserSecurityTab.js (security tab)
